export default [
  {
    key: 'agentId',
    label: 'field.agent',
    rules: 'required',
    type: 'nAsynSingleSelection',
    repository: 'agent',
    selectionKey: 'id',
    selectionLabel: 'username',
    clearable: true,
    cols: 2,
  },
]
